import {
    StripeButton,
    StripeButtonHandleErrorCallback,
} from '@eventbrite/payments';
import { logEvent } from '@eventbrite/statsig';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { submitCheckoutForm } from '../../../actions/checkout';
import { CHECKOUT_FORM_NAME } from '../../../constants';
import { STATSIG_EVENT_NAMES } from '../../../constants/statsig';
import { PaymentMethodType } from '../../../models/paymentMethods/enums';
import { getIsAppRebrandActive } from '../../../selectors/app';
import { getFormValues } from '../../../selectors/forms/pureSelectors';
import { getStripePaymentType } from '../../../selectors/stripe';
import { CheckoutState } from '../../../state';

const mapStateToProps = (state: CheckoutState) => {
    return {
        formData: getFormValues(state, CHECKOUT_FORM_NAME),
        stripePaymentType: getStripePaymentType(state),
        isAppRebrandActive: getIsAppRebrandActive(state),
    };
};

const mapDispatchToProps = (dispatch: Dispatch<CheckoutState>) => {
    return {
        submitFormCb: (
            token: { confirmationTokenID: string },
            formData: Record<string, any>,
            stripeRedirectedPaymentCallback: (
                paymentIntentClientSecret: string,
                handleErrorCallback: StripeButtonHandleErrorCallback,
            ) => Promise<void>,
        ) => {
            dispatch(
                submitCheckoutForm({
                    formData: {
                        ...formData,
                        payment: {
                            ...formData.payment,
                            ...token,
                        },
                        stripeRedirectedPaymentCallback,
                    },
                }),
            );
            logEvent(
                STATSIG_EVENT_NAMES.CHECKOUT_STEP_PLACE_ORDER_CLICK,
                undefined,
                { payment_method: PaymentMethodType.STRIPE_CONFIRMATION_TOKEN },
            );
        },
    };
};

export const ConnectedStripeButton = connect(
    mapStateToProps,
    mapDispatchToProps,
)(StripeButton);
